@if (!isEmpty(get(softwareStackRow, 'software_stack', ''))) {
  @for (row of get(softwareStackRow, 'software_stack.software_stack', []); track row; let i = $index) {
    <div>
      @if (!isEmpty(get(row, 'software_stack', ''))) {
        <section
          id="rows"
          class="d-flex flex-wrap flex-row justify-content-center container-gridless software-stacks"
          >
          <div class="category-top-title d-flex flex-row justify-content-center pb-2">
            <h2 class="col-md-7 text-center">
              {{ get(row, "software_stack_title", "") }}
            </h2>
          </div>
          @for (stack of get(row, 'software_stack', []); track stack) {
            <div class="col-xs-6 col-sm-6 col-md-4 col-lg-3 mb-3">
              <div id="group-card-image" class="d-flex flex-column justify-content-center card-1 text-center">
                <a
                  [routerLink]="get(stack, 'link.routerLink', '')"
                  [queryParams]="get(stack, 'link.queryParams', '')"
                  [class.inactive-link]="!stack?.link?.routerLink"
                  >
                  @if (get(stack, 'software_logo.href', '')) {
                    <img
                      [src]="get(stack, 'software_logo.href')"
                      [alt]="get(stack, 'software_logo.title', '')"
                      />
                  }
                </a>
              </div>
            </div>
          }
        </section>
      }
    </div>
  }
}
@if (get(softwareStackRow, 'software_stack.split_line', '')) {
  <hr class="m-0" />
}
